<template>
  <el-row
    type="flex"
    justify="center"
    align="middle"
    class="login"
  >

    <el-col class="login__col">

      <div class="login__supertext">Welcome to</div>
      <img src="../assets/logo.png">
      <div class="login__body">
        <div v-if="isAuthenticated">
          <p><strong>Hi {{ userName }},</strong></p>
          <p>
            You have already logged in to Viddsee Creator.<br>
            Click <el-button type="text"><router-link to="/">here</router-link></el-button> to go to the dashboard.
          </p>
        </div>
        <div v-else>

          <el-popover
            ref="loginnotice"
            placement="top"
            title="Notice for Existing User"
            :width="220"
            :offset="50"
            trigger="hover"
            :open-delay="2000"
          >
            We moved our email login to a new password-less system for better security.
            You use your current email address that you previously used to login, and we
            will send an email to you to proceed with the login.
          </el-popover>

          <div>
            <el-button
              class="login__button"
              v-popover:loginnotice
              @click="launchAuthPopup('sign_in')"
            >
              Login
            </el-button>
            <el-button
              class="login__button"
              @click="launchAuthPopup('sign_up')"
            >Sign up</el-button>
          </div>

          <div class="login__why-join">
            <a
              target="_blank"
              title="Open https://www.viddsee.com/join"
              href="https://www.viddsee.com/join"
              class="login__why-join__link"
            >
              Why join?
            </a>
          </div>
        </div>
      </div>
    </el-col>
  </el-row>

</template>

<script>
/* global BAKED_APPLICATION_VERSION */
import variables from '@/config/variables';

/**
 * @param {string} redirectTo
 * @param {'sign_in' | 'sign_up'} authMode
 * @param {Object} authTracker
 * @param {string} authTracker.client
 * @param {string} authTracker.screen_url
 * @param {string} authTracker.intent
 * @returns {string}
 */
const getAuthPopupUrl = (redirectTo, authMode, authTracker) => {
  const loginURLObj = new URL(`${variables.BASE_URL}/login`);
  loginURLObj.searchParams.append('origin', redirectTo);
  loginURLObj.searchParams.append('reason', btoa(JSON.stringify(authTracker)));
  loginURLObj.searchParams.append('auth_mode', authMode);

  return loginURLObj.href;
};

export default {
  methods: {
    /**
     * @param {'sign_in' | 'sign_up'} authMode
     */
    launchAuthPopup(authMode) {
      const redirectPath = this.$route.query.redirect || '/';
      const loginUrl = getAuthPopupUrl(
        location.href,
        authMode,
        {
          client: `creator@${BAKED_APPLICATION_VERSION}`,
          screen_url: location.origin + redirectPath,
          intent: this.$route.query.art_intent || null,
        },
      );

      window.popupLoggedIn = (callback, token) => {
        localStorage.setItem('access_token', token);
        this.$store.dispatch('account/initialiseAccount')
          .then(() => {
            delete window.popupLoggedIn;

            const redirection = this.$route.query.redirect || '/dashboard';
            this.$router.push(redirection);
          });
      };
      window.open(
        loginUrl,
        'newwindow',
        'width=992,height=600',
      );
    },
  },
  computed: {
    isAuthenticated() { return this.$store.state.account.isAuthenticated; },
    userName() {
      const userInfo = this.$store.state.account.blob;
      return `${userInfo.first_name} ${userInfo.last_name}`;
    },
  },
};
</script>

<style lang="scss">
.login {
  height: 70vh;
  text-align: center;

  img {
    width: 100%;
  }
}
.login__col {
  margin: auto;
  width: 100%;
  max-width: 420px;
}

.login__supertext {
  font-size: 1.4em;
  text-align: left;
  margin-bottom: 6px;
}

.login__body {
  margin-top: 5em;
}

.login__popover {
  display: inline;
  margin-left: 0.15em;
  opacity: 0.4;
}

.login__button {
  font-size: 1em;
  padding: 0.8em 2.4em;
  width: 160px;
  margin: 0.25em;
}

.login__why-join {
  margin-top: 2em;
}

.login__why-join__link {
  line-height: 1.5;
  display: inline-block;
  color: currentColor;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue